// extracted by mini-css-extract-plugin
module.exports = {"nav":"Breadcrumbs_nav__3sAWi","list":"Breadcrumbs_list__1E_Hd","link":"Breadcrumbs_link__2-YP2","current":"Breadcrumbs_current__1dvN6","separator":"Breadcrumbs_separator__2bvCt"};